module.exports = __webpack_public_path__ + "static/2bots-11084281b0a96779aca99c28e827bda2.png";